import { useNavigate } from "react-router-dom";
import { Trash } from "@phosphor-icons/react";
import { StatusBadge, AgingBadge } from "../badges";

export const OrdersTable = ({ orders, loading, emptyMessage, isAdmin, selected, toggleSelect, toggleSelectAll, deleteOrder }) => {
  const navigate = useNavigate();
  return (
    <div className="hidden overflow-x-auto rounded-md border border-slate-200 md:block">
      <table className="w-full text-sm">
        <thead className="sticky top-0">
          <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
            {isAdmin && (
              <th className="w-10 p-3">
                <input type="checkbox" data-testid="select-all-orders"
                  checked={orders.length > 0 && selected.length === orders.length}
                  onChange={toggleSelectAll} className="h-4 w-4 accent-slate-900" />
              </th>
            )}
            <th className="p-3">Order #</th>
            <th className="p-3">Customer</th>
            <th className="p-3">Location</th>
            <th className="p-3">Items</th>
            <th className="p-3 text-right">Qty</th>
            <th className="p-3">Status</th>
            <th className="p-3">Aging</th>
            <th className="p-3">Created</th>
            {isAdmin && <th className="p-3" />}
          </tr>
        </thead>
        <tbody data-testid="orders-table-body">
          {loading ? (
            <tr><td colSpan={isAdmin ? 10 : 8} className="p-6 text-center text-slate-400">Loading…</td></tr>
          ) : orders.length === 0 ? (
            <tr><td colSpan={isAdmin ? 10 : 8} className="p-6 text-center text-slate-400" data-testid="orders-empty-state">{emptyMessage}</td></tr>
          ) : (
            orders.map((o) => (
              <tr key={o.id} data-testid={`order-row-${o.order_number}`}
                onClick={() => navigate(`/orders/${o.id}`)}
                className="cursor-pointer border-b border-slate-100 transition-colors duration-150 hover:bg-slate-50">
                {isAdmin && (
                  <td className="w-10 p-3" onClick={(e) => e.stopPropagation()}>
                    <input type="checkbox" data-testid={`select-order-${o.order_number}`}
                      checked={selected.includes(o.id)} onChange={() => {}} onClick={(e) => toggleSelect(e, o.id)}
                      className="h-4 w-4 accent-slate-900" />
                  </td>
                )}
                <td className="p-3 font-mono font-medium text-slate-900">{o.order_number}</td>
                <td className="p-3 font-medium">{o.customer_name}</td>
                <td className="p-3 text-slate-500">{o.location}</td>
                <td className="p-3 text-slate-500">{o.items.length} item{o.items.length > 1 ? "s" : ""}</td>
                <td className="p-3 text-right font-mono">{o.total_quantity}</td>
                <td className="p-3"><StatusBadge status={o.status} label={o.status_label} /></td>
                <td className="p-3"><AgingBadge color={o.aging_color} days={o.age_days} /></td>
                <td className="p-3 whitespace-nowrap text-slate-500">{o.created_at.slice(0, 10)}</td>
                {isAdmin && (
                  <td className="p-3 text-right">
                    <button data-testid={`delete-order-button-${o.order_number}`} onClick={(e) => deleteOrder(e, o)}
                      title="Delete order"
                      className="text-slate-400 transition-colors duration-150 hover:text-red-600">
                      <Trash size={16} weight="duotone" />
                    </button>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
